import { compose } from 'recompose';
import apiInterceptor from '../../../api/interceptor';
import { newSrnVatApi } from '../../common/base.api';
import NewSRNVatReport from './NewSRNVatReport';

const composedNewSRNVatReport = compose(apiInterceptor({ ...newSrnVatApi }))(NewSRNVatReport);

export default composedNewSRNVatReport;
